module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Daphne Du Maurier\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Daphne du Maurier")]), _vm._v(" (1907-89) was born in London, the daughter of the actor Sir Gerald du Maurier and granddaughter of the author and artist George du Maurier. Her first novel, "), _c('I', [_vm._v("The Loving Spirit")]), _vm._v(", was published in 1931, but it would be her fifth novel, "), _c('I', [_vm._v("Rebecca")]), _vm._v(", that made her one of the most popular authors of her day. "), _c('br'), _c('br'), _vm._v(" Besides novels, du Maurier wrote plays, biographies, and several collections of short fiction. Many of her works were made into films, including "), _c('I', [_vm._v("Rebecca")]), _vm._v(", "), _c('I', [_vm._v("Jamaica Inn")]), _vm._v(", "), _c('I', [_vm._v("My Cousin Rachel")]), _vm._v(", \"Don't Look Now,\" and \"The Birds.\" She lived most of her life in Cornwall, and was made a Dame of the British Empire in 1969.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YMVMl1/images/9780316253543.jpg?1733085643023",
      "alt": "This image is the cover for the book Hungry Hill"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Hungry Hill\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The story of a deadly curse that afflicted an Irish family for a hundred years. "), _c('br'), _c('br'), _vm._v(" \"I tell you your mine will be in ruins and your home destroyed and your children forgotten . . . but this hill will be standing still to confound you.\" So curses Morty Donovan when Copper John Brodrick builds his mine at Hungry Hill. "), _c('br'), _c('br'), _vm._v(" The Brodricks of Clonmere gain great wealth by harnessing the power of Hungry Hill and extracting the treasure it holds. The Donovans, the original owners of Clonmere Castle, resent the Brodricks' success, and consider the great house and its surrounding land theirs by rights. For generations the feud between the families has simmered, always threatening to break into violence . . .")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Little, Brown and Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0